import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { motion } from 'framer-motion'
import React, { useRef } from 'react'
import { useParallaxCalculation } from '../../hooks/useParallax'
import DataTable from '../molecules/DataTable'
import InlinePlzTool from '../organisms/InlinePlzTool'

const M07TextImageAlternate = ({
  heading,
  copy,
  image,
  videos,
  youtubeId,
  disableShadow,
  variant,
  dataTableHeading,
  careersFeatureDataTable,
  hasPlzTool,
  anchorLinkId,
}) => {
  const ref1 = useRef(null)
  const ref2 = useRef(null)
  const { yRef1, yRef2, recalculateParallax } = useParallaxCalculation({
    ref1,
    ref2,
  })

  return (
    <section className="my-10 md:my-20" id={anchorLinkId}>
      <div className="container">
        <div className="row-type-e">
          {variant === 'imageLeft' && (
            <motion.div
              className="col-1-type-e"
              ref={ref2}
              style={{ y: yRef2 }}
            >
              {image.length > 0 && image[0] && (
                <img
                  src={image[0]?.url}
                  alt="Graph"
                  onLoad={recalculateParallax}
                  className={`w-full h-auto ${
                    !disableShadow && 'shadow-tpmp lg:shadow-dp'
                  }`}
                />
              )}
              {youtubeId && (
                <iframe
                  title=""
                  src={`https://www.youtube.com/embed/${youtubeId}?modestbranding=1&rel=0`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className={`w-full aspect-video ${
                    !disableShadow && 'shadow-tpmp lg:shadow-dp'
                  }`}
                ></iframe>
              )}
              {videos.length > 0 && (
                <video
                  width="auto"
                  height="100%"
                  muted
                  playsInline
                  autoPlay="autoplay"
                  loop
                  className="mb-8 sm:mb-0"
                  fetchpriority="high"
                  onLoadedData={recalculateParallax}
                >
                  <source
                    src={
                      videos.find(({ extension }) => extension === 'mp4')?.url
                    }
                    type='video/mp4; codecs="hvc1"'
                  />
                  <source
                    src={
                      videos.find(({ extension }) => extension === 'webm')?.url
                    }
                    type="video/webm"
                  />
                </video>
              )}
              {dataTableHeading && careersFeatureDataTable.length > 0 && (
                <DataTable
                  heading={dataTableHeading}
                  dataTable={careersFeatureDataTable}
                />
              )}
            </motion.div>
          )}
          <motion.div
            style={{ y: yRef1 }}
            ref={ref1}
            className={`${
              variant === 'imageLeft' ? 'col-2-type-e' : 'col-1-type-e'
            }`}
          >
            <h2 className="mt-8 mb-4 md:mt-0 u-h1 lg:mb-6 xl:mb-5">
              {heading}
            </h2>
            <div
              className="mb-5 copy u-p column-indent lg:mb-4 xl:mb-6 link-wrapper"
              dangerouslySetInnerHTML={{ __html: copy }}
            />
            {hasPlzTool && (
              <div className="mb-5 column-indent">
                <QueryClientProvider client={new QueryClient()}>
                  <InlinePlzTool />
                </QueryClientProvider>
              </div>
            )}
          </motion.div>
          {variant === 'imageRight' && (
            <motion.div
              className="col-2-type-e"
              ref={ref2}
              style={{ y: yRef2 }}
            >
              {image.length > 0 && image[0] && (
                <img
                  src={image[0]?.url}
                  alt="Graph"
                  onLoad={recalculateParallax}
                  className={`w-full h-auto ${
                    !disableShadow && 'shadow-tpmp lg:shadow-dp'
                  }`}
                />
              )}
              {youtubeId && (
                <iframe
                  title=""
                  src={`https://www.youtube.com/embed/${youtubeId}?modestbranding=1&rel=0`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className={`w-full aspect-video ${
                    !disableShadow && 'shadow-tpmp lg:shadow-dp'
                  }`}
                ></iframe>
              )}
              {videos.length > 0 && (
                <video
                  width="auto"
                  height="100%"
                  muted
                  playsInline
                  autoPlay="autoplay"
                  loop
                  className="mb-8 sm:mb-0"
                  fetchpriority="high"
                  onLoadedData={recalculateParallax}
                >
                  <source
                    src={
                      videos.find(({ extension }) => extension === 'mp4')?.url
                    }
                    type='video/mp4; codecs="hvc1"'
                  />
                  <source
                    src={
                      videos.find(({ extension }) => extension === 'webm')?.url
                    }
                    type="video/webm"
                  />
                </video>
              )}
              {dataTableHeading && careersFeatureDataTable.length > 0 && (
                <DataTable
                  heading={dataTableHeading}
                  dataTable={careersFeatureDataTable}
                />
              )}
            </motion.div>
          )}
        </div>
      </div>
    </section>
  )
}

export default M07TextImageAlternate
